module.exports = {
  addtocart: 'Add to cart',
  productinfo: 'Product',
  product: 'Product',
  productname: ' Product',
  cont: 'Quantity ',
  myinfo: 'My Info',
  sellcount: 'Sells ',
  qtys: '',
  ticket: '',
  minPrice: 'min Price',
  minutedelivery: 'minute delivery',
  offer: '',
  discountinformation: 'Discount information',
  merchantannouncement: 'Merchant announcement',
  deliveryprice: 'delivery price',
  deliverytime: 'delivery time',
  bulletin: 'Bulletin',
  pics: 'Pictures',
  info: 'Information',
  favorite: 'Favorite',
  favorited: 'Favorited',
  rating: 'Rating',
  pay: 'Pay',
  deliveryfee: 'delivery fee',
  cart: 'Cart',
  empty: 'Empty',
  total: 'Total',
  completeorder: 'Complete',
  orderid: 'OrderID',
  amounts: 'Amounts',
  ordersheet: 'Order sheet',
  backtomain: 'Back',
  back: 'Back',
  notsignin: 'Not sign in',
  signin: 'Sign in',
  signout: 'Sign out',
  register: 'register',
  username: 'Username',
  password: 'Password',
  captcha: 'Captcha',
  dsid: 'dsid',
  name: 'Name',
  phone: 'Phone',
  address: 'Address',
  zip: 'Zip',
  city: 'City',
  province: 'Province',
  pending: 'Pending',
  received: 'Received',
  complete: 'Complete',
  myaddress: 'My address',
  customerservice: 'Customer service',
  onlineservice: 'Online service',
  lessminprice: 'Less',
  todelivery: '',
  language: 'Language',
  confirmorder: 'Confirm Order',
  paymode: 'Pay mode',
  paymodearray: 'VISA | Cash | TakeAway',
  remark: 'Remark',
  sumbitorder: 'Submit Order',
  ordererror: 'Order error | Dirección incompleta! | Please login',
  delivery: 'Delivery',
  subtotal: 'Subtotal',
  newuser: 'New User',
  loginerror: 'Please enter a username | Please enter a password | Please enter a verification code | Login failure | Registration failure | Two passwords no same | Username already exists | Failed to modify data',
  loginerror0: 'Please enter a username',
  loginerror1: 'Please enter a password',
  loginerror2: 'Please enter a verification code',
  loginerror3: 'Login failure',
  loginerror4: 'Registration failure',
  loginerror5: 'Two passwords no same',
  loginerror6: 'Username already exists',
  loginerror7: 'Failed to modify data',
  mydescription: 'My Profile',
  description: 'Nickname',
  password2: 'Confirm password(Leave blank if not changed)',
  newusertips: 'Username already exists, please re-enter | Congratulations to the username you entered can be used',
  completemydirecion: 'Please open the address function and fill in a valid address',
  prompt: 'Prompt'
}



// WEBPACK FOOTER //
// ./src/i18n/en.js